import {
  LEVITA_URL,
  MINI_SERVER_URL,
  BASE_URL,
  FIREBASE_FUNCTIONS_URL,
  NOMMY_URL,
} from 'utils/axios-request';

const configuration = {
  // Rutas del backend v2 (LEVITA_URL) — iguales en cualquier ambiente, por eso
  // viven fuera de production/develop en lugar de duplicarse (antes solo
  // existían dentro de `production`, así que en local, con NODE_ENV forzado a
  // "development" por react-scripts, quedaban todas `undefined`).
  paths: {
    // PATHS
    pathGenerateComplement: '/invoice/complement',
    pathGenerateManyComplement: '/invoice/many-complement',
    pathUploadPagos: '/conciliaciones/upload',
    pathGetConciliaciones: '/conciliaciones',
    pathGetConciliacionesV2: '/conciliacionesv2',
    pahtGetDivisas: '/catalogs/divisas',
    pahtGetFormasDePago: '/catalogs/formas-pago',
    pahtGetBanxicoTipoCambio: '/catalogs/banxico',
    pahtGetADCs: '/catalogs/adcs',
    pahtVerifyConciliacion: '/conciliaciones/verify',
    pathGetIncoporadosEmpleados: '/incorporados-empleados',
    pathGetIncoporadosEmpleadosReport: '/incorporados-empleados/xlsx',
    pathAddNewDocumentHandler: '/new-documents/add',
    pathAttachNewDocumentHandler: '/new-documents/attach',
    pathGetNewDocumentHandler: '/new-documents-get',
    pathGetNewDocumentFileHandler: '/new-documents-download',
    pathGetNewDocumentCatalogsHandler: '/new-documents/catalogs',
    pathGetSimpleSocietiesHandler: '/simple-societies',
    // pahtGetADCListV2: '/adc-list',
    // pathGetADCPayrollPeriods: '/adc-payroll-periods', // baseURL¿
    pathUpdatePayrollPeriodStatus: '/update-payroll-period-status',
    pathOnOffPayrollStatus: '/on-off-payroll-status',
    pathSearchClients: '/clients/search',
    pathSimplePayrolls: '/simple-payrolls',
    pathSimplePayrollBranch: '/simple-payroll-branch',
    pathSimpleContractTypes: '/simple-contract-types',
    // pathBankAccountsLayout: '/bank-accounts-layout',
    // pathBankAccountsImport: '/bank-accounts-import',
    // pathADCCatalogue: '/get-adc-catalogue',
    // pathSendEmailADCPayrollPeriodsV2: '/send-email-adc-report-v2', // baseURL
    // pathAddIMSSFile: '/add-imss-file',
    // pathAttachIMSSFile: '/attach-imss-file',
    // pathGetIMSSFiles: '/get-imss-files',
    // pathGetDownloadIMSSFile: '/download-imss-file',
    pathDismissalOperationSUAJunction: '/dismissal/operation/sua-junction',
    pathSUAOperationReentry: '/sua/operation/reentry',
    // pathSurveyFrequency: '/survey-frequency',
    pathSurveyApproveEmails: '/survey-approve-emails',
    pathSurveyAccess: '/survey-access',
    path: {
      documentAdd: 'document/add',
      documentAll: 'document/all',
      announcementAll: 'announcement/all',
      announcementOne: 'announcement/one',
      announcementAdd: 'announcement/add',
      announcementRemove: 'announcement/remove',
      announcementSend: 'announcement/send',
      announcementContacts: 'announcement/contacts',
    },
  },
  firebase: {
    // PATHS
    pathGenerateComplement: '/createComplementHandlerV2',
    pathGenerateManyComplement: '/createManyComplementHandlerV2',
    pathUploadPagos: '/uploadConciliacionesFromExcelHandler',
    pathGetConciliaciones: '/getComplementosDePago',
    pathGetConciliacionesV2: '/getComplementosDePagoV2',
    pahtGetDivisas: '/getDivisasHandler',
    pahtGetFormasDePago: '/getFormasDePagoHandler',
    pahtGetBanxicoTipoCambio: '/getTipoCambioBanxicoHandler',
    pahtGetADCs: '/getADCListHandler',
    pahtVerifyConciliacion: '/isGeneratingPayingHandler',
    pathAddExternalEmployee: '/addExternalEmployeeHandler',
    pathEditExternalEmployee: '/editExternalEmployeeHandler',
    pathGetExternalEmployees: '/getExternalEmployeesHandler',
    pathGetIncoporadosEmpleados: '/getIncorporadosEmpleadosReport',
    pathGetIncoporadosEmpleadosReport: '/exportIncorporadosEmpleadosReport',
    pathAddNewDocumentHandler: '/addNewDocumentHandler',
    pathAttachNewDocumentHandler: '/attachNewDocumentHandler',
    pathGetNewDocumentHandler: '/getNewDocumentHandler',
    pathGetNewDocumentFileHandler: '/getNewDocumentFileHandler',
    pathGetNewDocumentCatalogsHandler: '/getNewDocumentCatalogsHandler',
    pathGetSimpleSocietiesHandler: '/getSimpleSocietiesHandler',
    pahtGetADCListV2: '/getADCListV2',
    pathUpdatePayrollPeriodStatus: '/updatePayrollPeriodStatus',
    // pathGetStrapiProfilePicture: '/getStrapiProfilePicture',
    pathOnOffPayrollStatus: '/onOffPayrollStatus',
    pathSearchClients: '/searchClients',
    pathSimpleClients: '/getSimpleClients',
    pathSimplePayrolls: '/getSimplePayrolls',
    pathSimplePayrollBranch: '/getSimplePayrollBranch',
    pathSimpleContractTypes: '/getSimpleContractTypes',
    pathBankAccountsLayout: '/getBankAccountsLayoutV2',
    pathBankAccountsImport: '/getBankAccountsImport',
    pathADCCatalogue: '/getADCCatalogue',
    pathAddIMSSFile: '/addIMSSFile',
    pathAttachIMSSFile: '/attachIMSSFile',
    pathGetIMSSFiles: '/getIMSSFiles',
    pathDeleteIMSSFile: '/deleteIMSSFile',
    pathDismissalOperationSUAJunction: '/dismissal/operation/sua-junction',
    pathSUAOperationReentry: '/sua/operation/reentry',
    pathSurveyApproveEmails: '/getSurveyApproveEmails',
    pathSurveyAccess: '/getSurveyAccess',
    pathGetADCPayrollPeriods: '/getADCPayrollPeriods',
    pathGetDownloadIMSSFile: '/getDownloadIMSSFile',
    pathGenerateLayoutSISUB: '/generateLayoutSISUB',
    pathSurveyFrequency: '/getSurveyFrequency',
    pathSendEmailADCPayrollPeriodsV2: '/sendEmailADCPayrollPeriodsV2',
    pathDeleteEmployeeStatusRequest: '/deleteEmployeeStatusRequest',
    pathMulticreatedEmployeeStatusRequest: '/multicreatedEmployeeStatusRequest',
    pathGetEmployeeStatusRequestList: '/getEmployeeStatusRequestList',
    pathApproveEmployeeStatusRequest: '/approveEmployeeStatusRequest',
    pathGetManyExternalEmployeeLayout: '/getManyExternalEmployeeLayout',
    pathAddManyExternalEmployee: '/addManyExternalEmployee',
    pathGetTotalPerceptions: '/totalPerceptions',
    pathGetTotalPerceptionsV2: '/totalPerceptionsV2',
    pathGetVariacionesTotalDispersado: '/getVariacionesTotalDispersado',
    pathGetVariacionesTotalDispersadoXLSX: '/getVariacionesTotalDispersadoXLSX',
    pathGetADCDashboard: '/getADCDashboard',
    pathCustomRole: '/customRole',
    pathSurveyADCConfig: '/surveyADCConfig',
    pathSurveyStatus: '/surveyNOM035Status',
    pathGetNoministaList: '/getNoministaList',
    pathGetNoministaPayrollPeriods: '/getNoministaPayrollPeriods',
    pathGetNoministaPayrollPeriodsV2: '/getNoministaPayrollPeriodsV2',
    pathGetLoadBalanceNominista: '/getLoadBalanceNominista',
    pathGetLoadBalanceNoministaXLSX: '/getLoadBalanceNoministaXLSX',
    pathFindCandidatePayrolls: '/findCandidatePayrolls',
    pathPayrollFrequencies: '/payrollFrequencies',
    pathGetPayrollsByClientAndFrequency: '/getPayrollsByClientAndFrequency',
    pathAsignarNominista: '/asignarNominista',
    pathGetReportNoministaPayrollPeriodsXLSX:
      '/getReportNoministaPayrollPeriodsXLSX',
    pathGetReportNoministaPayrollPeriodsXLSXV2:
      '/getReportNoministaPayrollPeriodsXLSXV2',
    pathOnOffPayrollStatusNominista: '/onOffPayrollStatusNominista',
    pathPlacesV2: '/placesV2',
    pathGetVariacionesTotalDispersadoMetricas:
      '/getVariacionesTotalDispersadoMetricas',
    pathGetVariacionesTotalDispersadoMetricasXLSX:
      '/getVariacionesTotalDispersadoMetricasXLSX',
    pathGetClientesDispersan: '/getClientesDispersan',
    pathGetClientesDispersanXLSX: '/getClientesDispersanXLSX',
    pathGetUserInfo: '/getUserInfo',
    pathPayrollPeriodsCatalogs: '/payrollPeriodsCatalogs',
    pathGetSocietyValidations: '/getSocietyValidations',
    pathCreateSocietyValidation: '/createSocietyValidation',
    pathUpdateSocietyValidation: '/updateSocietyValidation',
    pathDeleteSocietyValidation: '/deleteSocietyValidation',
    pathGetSocietyValidationById: '/getSocietyValidationById',
    pathUpdateVariacionesTotalDispersadoMetas:
      '/updateVariacionesTotalDispersadoMetas',
    pathGetVariacionesTotalDispersadoMetasDocument:
      '/getVariacionesTotalDispersadoMetasDocument',
    // Account Statement - Estado de Cuenta
    pathAccountStatementCreateProvision: '/accountStatementCreateProvision',
    pathAccountStatementApplyProvision: '/accountStatementApplyProvision',
    pathAccountStatementGetAvailableBalance:
      '/accountStatementGetAvailableBalance',
    pathAccountStatementRefundProvision: '/accountStatementRefundProvision',
    pathAccountStatementCreateTransaction: '/accountStatementCreateTransaction',
    pathAccountStatementReadTransactions: '/accountStatementReadTransactions',
    pathAccountStatementReverseTransaction:
      '/accountStatementReverseTransaction',
    pathAccountStatementGetTransactionsSummary:
      '/accountStatementGetTransactionsSummary',
    pathAccountStatementReadAccounts: '/accountStatementReadAccounts',
    pathAccountStatementGetOrCreateAccount:
      '/accountStatementGetOrCreateAccount',
    pathAccountStatementReadAuditLogs: '/accountStatementReadAuditLogs',
    pathGetInvoicesByPayrollPeriodsByClient:
      '/getInvoicesByPayrollPeriodsByClient',
    pathGetInvoicesByPayrollPeriodsByClientXLSX:
      '/getInvoicesByPayrollPeriodsByClientXLSX',
    pathAsignEmployeesDone: '/asignEmployeesDone',
    // Financing — Solicitudes de Financiamiento
    pathFinanciamientoCrearSolicitud: '/financiamientoCrearSolicitud',
    pathFinanciamientoActualizarSolicitud: '/financiamientoActualizarSolicitud',
    pathFinanciamientoEnviarSolicitud: '/financiamientoEnviarSolicitud',
    pathFinanciamientoListarSolicitudes: '/financiamientoListarSolicitudes',
    pathFinanciamientoObtenerSolicitud: '/financiamientoObtenerSolicitud',
    pathFinanciamientoAprobarSolicitud: '/financiamientoAprobarSolicitud',
    pathFinanciamientoRechazarSolicitud: '/financiamientoRechazarSolicitud',
    pathFinanciamientoCancelarSolicitud: '/financiamientoCancelarSolicitud',
    pathFinanciamientoPresignPago: '/financiamientoPresignPago',
    pathFinanciamientoPresignGetComprobante:
      '/financiamientoPresignGetComprobante',
    pathFinanciamientoRegistrarPago: '/financiamientoRegistrarPago',
    pathFinanciamientoAprobarEmail: '/financiamientoAprobarEmail',
    pathFinanciamientoRechazarEmail: '/financiamientoRechazarEmail',
    pathFinanciamientoListarClientes: '/financiamientoListarClientes',
    pathFinanciamientoPreviewAprobacion: '/financiamientoPreviewAprobacion',
    pathFinanciamientoConfirmarAprobacion: '/financiamientoConfirmarAprobacion',
    pathFinanciamientoPreviewRechazo: '/financiamientoPreviewRechazo',
    pathFinanciamientoConfirmarRechazo: '/financiamientoConfirmarRechazo',
    pathFinanciamientoEliminarPago: '/financiamientoEliminarPago',
  },
  nommy: {
    pathGetStrapiProfilePicture: '/public/external/profile-picture',
  },
};

// Todas las URLs de abajo vienen de variables de entorno (ver hosting/.env,
// bloques #PRODUCTION / #DEVELOP) — ya no dependen de NODE_ENV, que
// react-scripts fuerza a "development" en `npm start` sin importar lo que
// diga .env, haciendo inútil un switch basado en NODE_ENV en este archivo.
const finalConfiguration = {
  ...configuration.firebase,
  ...configuration.nommy,
  ...configuration.paths,
  baseURL: BASE_URL,
  firebaseURL: FIREBASE_FUNCTIONS_URL,
  levitaURL: `${LEVITA_URL}/v2`,
  nommyURL: NOMMY_URL,
  // Rutas: `${miniServerURL}/<CloudFunctionName>` (ver ../mini-levita-server/src/legacy/ROUTE_MAP.md).
  miniServerURL: `${MINI_SERVER_URL}/v1`,
  // T10/D3 — create-flow lookups (list-client-payrolls/list-payroll-periods/list-payroll-societies).
  // These are new VSA slices under `/financing`, NOT part of the `/v1` Cloud Function migration —
  // see mini-levita-server's `src/features/financing-intake/`.
  financingIntakeURL: `${MINI_SERVER_URL}/financing`,
};

export default finalConfiguration;
